import React, { useState } from "react";

import ham from "../../media/ham.svg";
import cross from "../../media/cross.svg";
import "./Toggle.css";

const Toggle = (props) => {
  const { click } = props;

  const [toggle, setToggle] = useState("");
  const [logo, setLogo] = useState(ham);
  const [value, setValue] = useState(0);
  const bClass = "navbar-hamburger" + toggle;
  const handleToggle = (e) => {
    e.preventDefault();
    if (toggle === "") {
      setToggle("-active");
      setLogo(cross);
      setValue(-1);
    } else {
      setToggle("");
      setLogo(ham);
      setValue(0);
    }
    click(value);
  };

  return (
    <div className="toggle">
      <div className={bClass}>
        <img src={logo} alt="ham" onClick={handleToggle} />
      </div>
    </div>
  );
};

export default Toggle;
